/**
 * Visual tuning constants shared across the Pulse render subsystem.
 * Centralised here so a future pass can adjust the "feel" of the
 * playfield without hunting through every draw module.
 */

/** Star count for the parallax bg layer. */
export const STAR_COUNT = 90;

/** Width of the floor / ceiling rails in CSS px. */
export const RAIL_THICKNESS = 4;

/**
 * Ghost-cube + pre-flip arrow are training wheels for new players: they
 * teach the "tap = appear on the opposite rail" mechanic the moment the
 * pad arrives. Once the player has banked this many successful required
 * hits in the run, both fade out so experts aren't visually nagged.
 */
export const TRAINING_WHEELS_HIDE_AFTER_HITS = 5;

/**
 * Wall-clock arc tween duration (ms) for the player position when
 * `state.currentSurface` flips. The engine still flips instantly on
 * the input frame; the arc is a pure cosmetic re-render, so timing
 * windows and scroll math are untouched. Duration is intentionally
 * shorter than `PERFECT_WINDOW_MS` so the visual never lingers into
 * the next required hit.
 */
export const ARC_DURATION_MS = 80;

/** Particle pool cap — heavy bursts on a long song can otherwise unbounded-grow. */
export const PARTICLE_POOL_MAX = 600;
